import qs from 'qs';
import { dataSender, getData } from '../../common/utils/router';
import { API_SERVER_URL, getFilterForPage, saveFilterForPage } from '../../common/utils/utils';

export const changeTableItemsLengthFunc = (
    data,
    dataFiltersToUrl,
    dataFiltersItemsCountToUrl,
    setSelectedLengthItems,
    setGridData,
    convertData,
    setAlertData,
    userToken,
    lang,
    url,
    setUrl,
    filterParams,
    token,
    filter,
    sort,
    router
) => {
    const sortParams = sort ? `&sort=${sort}` : '';
    let getParams = dataFiltersToUrl.current
        ? `?${dataFiltersToUrl.current}&page[size]=${data}${filterParams ? '&' + filterParams : ''}${sortParams}`
        : `?page[size]=${data}${filterParams ? '&' + filterParams : ''}${sortParams}`;
    dataFiltersItemsCountToUrl.current = `page[size]=${data}`;
    if (filter?.categoryView) {
        url = `${API_SERVER_URL}/api/v1/admin/shop/product-categories`;
        getParams += '&filter[parent_id]=0';
    }
    let local_storage_params = getFilterForPage(router?.route);
    const parsed_local_storage_params = qs.parse(local_storage_params);
    if (parsed_local_storage_params?.page?.size) {
        delete parsed_local_storage_params.page;
    }
    local_storage_params = qs.stringify(parsed_local_storage_params);
    saveFilterForPage(router?.route, { ...parsed_local_storage_params, page: { size: data } });
    if (parsed_local_storage_params?.filter) {
        getParams += `&${local_storage_params}`;
    }
    dataSender(
        url ? `${url}${getParams}` : `${API_SERVER_URL}/api/v1/admin/user-management/users${getParams}`,
        'GET',
        false,
        (response) => {
            setUrl && setUrl(`${url}${getParams}`);
            setSelectedLengthItems(data);
            setGridData((pre) => ({
                ...pre,
                tbody: convertData(response.data)
            }));
        },
        (data) => {
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData(false);
            }
        },
        token ? token : userToken,
        lang
    );
};

export const globalSearchFunc = async (
    text,
    setDataFiltersToUrl,
    setTextToGlobalSearch,
    convertData,
    dataFiltersItemsCountToUrl,
    setGridData,
    userToken,
    lang,
    url,
    filterParams,
    setUrl,
    token,
    categoryView,
    filter,
    router
) => {
    setTextToGlobalSearch(text);
    if (text.length >= 2 || text.length === 0) {
        let filterQ = text ? `filter[q]=${text}` : '';
        let localStorageFilters = getFilterForPage(router?.route);
        if (localStorageFilters) {
            filterQ += filterQ ? `&${localStorageFilters}` : localStorageFilters;
            const showBy = qs.parse(localStorageFilters);
            if (typeof showBy?.page?.size === 'string') {
                dataFiltersItemsCountToUrl.current = `page[size]=${showBy?.page?.size}`;
            }
        }
        setDataFiltersToUrl(filterQ);
        let getParams =
            dataFiltersItemsCountToUrl.current && !localStorageFilters
                ? `?${dataFiltersItemsCountToUrl.current}&${filterQ}${filterParams ? (filterQ ? '&' : '') + filterParams : ''}`
                : `?${filterQ}${filterParams ? (filterQ ? '&' : '') + filterParams : ''}`;

        if (categoryView) {
            if (text.length === 0) {
                url = `${API_SERVER_URL}/api/v1/admin/shop/product-categories`;
                getParams = `?page[size]=10&filter[parent_id]=0${filterParams ? '&' + filterParams : ''}`;
            }
        }
        setUrl(url ? `${url}${getParams}` : `${API_SERVER_URL}/api/v1/admin/user-management/users${getParams}`);
        const response = await getData(
            url ? `${url}${getParams}` : `${API_SERVER_URL}/api/v1/admin/user-management/users${getParams}`,
            token ? token : userToken,
            lang
        );

        if (categoryView && text.length >= 2) {
            const res = {
                ...response,
                data: [
                    ...response.data.reduce((accum, val) => {
                        const data = val?.children_tree?.data || val?.children_tree;
                        accum = [...accum];
                        accum.push({
                            ...val,
                            isOpen: data && val.has_children
                        });
                        if (data) {
                            function pushChildRecursive(item) {
                                item.forEach((el) => {
                                    const elData = el?.children_tree?.data || el?.children_tree;
                                    accum.push({
                                        ...el,
                                        isOpen: elData && el.has_children
                                    });
                                    if (elData) {
                                        pushChildRecursive(elData);
                                    }
                                });
                            }

                            pushChildRecursive(data);
                        }
                        return accum;
                    }, [])
                ]
            };
            const converted = convertData(res);
            setGridData(
                (pre) => ({
                    ...pre,
                    tbody: filter?.showDataOnlyWithFilter ? (!text ? [] : converted) : converted
                }),
                response
            );
        } else {
            setGridData(
                (pre) => ({
                    ...pre,
                    tbody: filter?.showDataOnlyWithFilter ? (!text ? [] : convertData(response)) : convertData(response)
                }),
                response
            );
        }
    }
};

export const sendFilterFunc = (
    groupFormData,
    filterData,
    setAllowedSend,
    setGroupFormDataError,
    setAlertData,
    dataFiltersItemsCountToUrl,
    setGridData,
    convertData,
    userToken,
    setDataFiltersToUrl,
    lang,
    filter,
    convertHeadData,
    setUrl,
    token,
    setShowLoading,
    inputGlobFilter,
    setShowModal,
    sort,
    router
) => {
    let sendData;
    if (filter.transformSendData) {
        sendData = filter.transformSendData(groupFormData);
    } else {
        const fields = Object.keys(filterData).reduce((acc, curr) => [...acc, ...filterData[curr]?.fields], []);

        sendData = Object.keys(groupFormData).reduce((accum, key) => {
            const type = fields.find((f) => f?.attribute === key)?.type;
            if (!groupFormData[key]) return accum;
            if (type === 'range-date-widget') {
                if (key.includes('_between')) {
                    let start = '';
                    let end = '';
                    if (groupFormData[key]?.start) {
                        start = `${groupFormData[key]?.start} 00:00:00`;
                    }
                    if (groupFormData[key]?.end) {
                        end = `${groupFormData[key]?.end} 23:59:59`;
                    } else if (groupFormData[key]?.start) {
                        end = `${groupFormData[key]?.start} 23:59:59` || null;
                    }
                    if (!start && !end) {
                        return accum;
                    }
                    accum[`filter[${key}]`] = `${start}${start && end ? ',' : ''}${end}` || null;
                } else {
                    const newKey = key[key.length - 1] === '_' ? key.slice(0, -1) : key;
                    if (groupFormData[key]?.start) {
                        accum[`filter[${newKey}_after]`] = groupFormData[key]?.start || null;
                    }
                    if (groupFormData[key]?.end) {
                        accum[`filter[${newKey}_before]`] = groupFormData[key]?.end || null;
                    } else if (groupFormData[key]?.start) {
                        accum[`filter[${newKey}_before]`] = groupFormData[key]?.start || null;
                    }
                }
            } else if (type === 'dropdown-multiselect') {
                if (
                    (!groupFormData[key].length && !filter?.saveFilterParams && typeof groupFormData[key] !== 'string') ||
                    !groupFormData[key].length
                ) {
                    return accum;
                }
                let value =
                    typeof groupFormData[key] === 'string'
                        ? groupFormData[key]
                        : groupFormData[key].reduce((accum, item) => {
                              return accum + `${item.id},`;
                          }, '');
                accum[`filter[${key}]`] = typeof groupFormData[key] === 'string' ? value : value.slice(0, -1);
            } else if (['dropdown', 'select', 'select-data-widget', 'location_widget'].includes(type)) {
                accum[`filter[${key}]`] =
                    groupFormData[key]?.id ||
                    groupFormData[key]?.value ||
                    (['string', 'number'].includes(typeof groupFormData[key]) ? groupFormData[key] : undefined);
            } else {
                accum[`filter[${key}]`] = groupFormData[key];
            }
            return accum;
        }, {});
    }

    if (filter?.startFilterValueGlobeSearch) {
        filter.startFilterValueGlobeSearch = '';
    }

    const searchParams = qs.stringify(sendData, { encode: true });
    const sortParams = sort ? `sort=${sort}` : '';

    const resultParams = [searchParams, sortParams, dataFiltersItemsCountToUrl.current].filter((f) => f).join('&');
    const getParams = `?${resultParams}`;
    setDataFiltersToUrl(searchParams);

    if (filter?.saveFilterParams) {
        saveFilterForPage(router?.route, resultParams);
    }

    setUrl(filter?.url ? `${filter.url}${getParams}` : `${API_SERVER_URL}/api/v1/admin/user-management/users${getParams}`);
    if (inputGlobFilter?.[0]) {
        inputGlobFilter?.[1]('');
    }
    setShowLoading(true);

    dataSender(
        filter?.url
            ? `${filter.url}${getParams}${filter.filterParams ? `&${filter.filterParams}` : ''}`
            : `${API_SERVER_URL}/api/v1/admin/user-management/users${getParams}${
                  filter.filterParams ? `&${filter.filterParams}` : ''
              }`,
        'GET',
        false,
        (response) => {
            setShowLoading(false);
            setGroupFormDataError({});
            setAllowedSend(true);
            if (filter?.categoryView && groupFormData?.name?.length > 0) {
                function pushChildRecursive(item) {
                    const resultArray = [];
                    item.forEach((el) => {
                        resultArray.push({
                            ...el,
                            isOpen: el?.children_tree?.data && el.has_children
                        });
                        if (el?.children_tree?.data) {
                            const result = pushChildRecursive(el.children_tree.data);
                            result.forEach((item) => {
                                resultArray.push(item);
                            });
                        }
                    });
                    return resultArray;
                }
                const res = {
                    ...response.data,
                    data: [
                        ...response.data.data.reduce((accum, val) => {
                            accum = [
                                ...accum,
                                {
                                    ...val,
                                    isOpen: val?.children_tree?.data && val.has_children
                                }
                            ];
                            if (val?.children_tree?.data) {
                                const result = pushChildRecursive(val.children_tree.data);
                                result.forEach((item) => {
                                    accum.push(item);
                                });
                            }
                            return accum;
                        }, [])
                    ]
                };
                const converted = convertData(res);
                setGridData(
                    (pre) => ({
                        ...pre,
                        ...(convertHeadData ? { thead: convertHeadData(response.data) } : {}),
                        tbody: converted
                    }),
                    response.data
                );
                setShowModal(false);
            } else {
                setShowModal(false);
                setGridData(
                    (pre) => ({
                        ...pre,
                        ...(convertHeadData ? { thead: convertHeadData(response.data) } : {}),
                        tbody: convertData(response.data)
                    }),
                    response.data
                );
            }
        },
        (data) => {
            setShowLoading(false);
            if (data.message) {
                setAlertData({ type: 'error', cont: data.message });
            } else {
                setAlertData(false);
            }

            if (data.errors && Object.keys(data.errors).length) {
                setGroupFormDataError(data.errors);
            }

            setAllowedSend(true);
        },
        token ? token : userToken,
        lang
    );
};
const getSortFunct =
    (
        sort,
        filter,
        dataFiltersToUrl,
        dataFiltersItemsCountToUrl,
        token,
        userToken,
        lang,
        setGridData,
        setUrl,
        convertData,
        setSort
    ) =>
    async (name) => {
        const newSort = sort === name ? `-${name}` : name;
        const sortParams = newSort ? `sort=${newSort}` : '';
        const otherParams = [sortParams, dataFiltersToUrl.current, dataFiltersItemsCountToUrl?.current, filter.filterParams]
            .filter((f) => f)
            .join('&');
        const domain = filter.url || `${API_SERVER_URL}/api/v1/admin/user-management/users`;
        const newUrl = [domain, otherParams].filter((f) => f).join('?');
        setUrl(newUrl);
        const response = await getData(newUrl, token ? token : userToken, lang, false, filter?.currency || false);
        setGridData(
            (pre) => ({
                ...pre,
                tbody: convertData(response)
            }),
            response
        );
        setSort(newSort);
    };

export const getSortData = (
    theadData,
    sort,
    filter,
    dataFiltersToUrl,
    token,
    userToken,
    lang,
    setGridData,
    setUrl,
    convertData,
    setSort,
    dataFiltersItemsCountToUrl
) => {
    const sortFunct = getSortFunct(
        sort,
        filter,
        dataFiltersToUrl,
        dataFiltersItemsCountToUrl,
        token,
        userToken,
        lang,
        setGridData,
        setUrl,
        convertData,
        setSort
    );
    return theadData?.reduce((acc, item) => {
        if (item?.sort) {
            return {
                ...acc,
                [item?.name]: {
                    active: sort === item?.sort ? 'down' : sort === `-${item?.sort}` ? 'up' : false,
                    func: () => sortFunct(item?.sort)
                }
            };
        }
        return acc;
    }, {});
};
